import React from 'react';
import { IconButton, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import styles from './styles';

const PF2MFullScreenButton = ({
  isFullScreenActive,
  open,
  close,
  variant,
  classes,
  iconButtonClasses,
}) => {
  const isGhost = variant === 'ghost';

  const handleClick = isFullScreenActive ? close : open;

  const Icon = isFullScreenActive ? FullscreenExitIcon : FullscreenIcon;

  const variantClasses = {
    filled: classes.filled,
    outlined: classes.outlined,
  };

  const variantClass = variantClasses[variant] || classes.outlined;

  if (!isGhost) {
    return (
      <IconButton
        onClick={handleClick}
        classes={{
          root: `${classes.root} ${variantClass} ${iconButtonClasses}`,
        }}
        style={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <Icon fontSize="small" />
      </IconButton>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <button
        type="button"
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          margin: 0,
          cursor: 'pointer',
          outline: 'none',
        }}
        onClick={handleClick}
      >
        <Icon fontSize="medium" />
      </button>
    </div>
  );
};

PF2MFullScreenButton.propTypes = {
  isFullScreenActive: PropTypes.bool,
  open: PropTypes.func,
  close: PropTypes.func,
  variant: PropTypes.oneOf(['ghost', 'filled', 'outlined']),
  classes: PropTypes.object.isRequired,
  iconButtonClasses: PropTypes.string,
};

PF2MFullScreenButton.defaultProps = {
  isFullScreenActive: false,
  open: () => null,
  close: () => null,
  variant: 'ghost',
  iconButtonClasses: '',
};

export default withStyles(styles)(PF2MFullScreenButton);
